export const paginationOnEndReach = (e, func) => {
  const bottom =
    e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
  if (bottom) {
    func();
  }
};